import "./styles/main.css";
import { initDialogs, initMailTemplates, initNextEvent, initTone, initButtons, initChapters, initPosters, initBackLinks } from "./ui-runtime";

const html = document.documentElement;

initNextEvent();
initDialogs();
initMailTemplates();
initTone();
initButtons();
initChapters();
initPosters();
initBackLinks();

if (html.classList.contains("motion")) {
  import("./motion")
    .then((m) => m.start())
    .catch((err) => {
      console.error(err);
      html.classList.remove("motion");
      html.classList.add("no-motion");
    })
    .finally(() => html.classList.add("booted"));
} else {
  html.classList.add("booted");
}
